import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { PhoneLink } from 'web-ui-components/lib/actions/links';
import { Content } from '../../infrastructure/content';
import { getQueryStringValueByName } from '../../utils';
import { CASE_ID, OFFER_CASE_ID } from '../../utils/constants';

const CreditCheckDeferredPage = () => (
  <Content>
    {({
      creditCheckDeferredPageTitle = '',
      creditCheckDeferredContent1,
      creditCheckDeferredContent2,
      creditCheckDeferredContent2_1,
      creditCheckDeferredContent3,
      creditCheckDeferredContent4,
      creditCheckDeferredContent5,
      creditCheckDeferredContent6,
      creditCheckDeferredContent7,
      creditCheckDeferredContent8,
      creditCheckDeferredContent9,
      creditCheckDeferredContent10,
      creditCheckDeferredContent11a,
      creditCheckDeferredUploadLink,
      creditCheckDeferredUploadLinkTitle,
      creditCheckDeferredContent11b,
      creditCheckDeferredContent12,
      creditCheckDeferredContent13,
      creditCheckDeferredContent14,
      creditCheckDeferredContent15,
      creditCheckDeferredContentPhoneNo
    }) => (
      <div>
        <PageHeading>{creditCheckDeferredPageTitle}</PageHeading>
        <StandardBody>
          <p>{creditCheckDeferredContent1}</p>
          <p>
            {creditCheckDeferredContent2}{' '}
            {getQueryStringValueByName(CASE_ID) || getQueryStringValueByName(OFFER_CASE_ID)}{' '}
            {creditCheckDeferredContent2_1}
          </p>
          <p>
            <SectionHeading>{creditCheckDeferredContent3}</SectionHeading>
          </p>
          <p>{creditCheckDeferredContent4}</p>
        </StandardBody>
        <BulletList
          items={[
            creditCheckDeferredContent5,
            creditCheckDeferredContent6,
            creditCheckDeferredContent7,
            creditCheckDeferredContent8
          ]}
        />
        <StandardBody>
          <p>
            <ActionButton.Upload
              labelText={creditCheckDeferredContent9}
              onClick={() => {
                window.open(creditCheckDeferredUploadLink, '_balnk');
              }}
            />
          </p>

          <p>
            <SectionHeading>{creditCheckDeferredContent10}</SectionHeading>
          </p>
          <p>
            {creditCheckDeferredContent11a}
            <WebsiteLink
              linkText={creditCheckDeferredUploadLinkTitle}
              url={creditCheckDeferredUploadLink}
              willOpenNewWindow
            />{' '}
            {creditCheckDeferredContent11b}
          </p>
          <p>
            {creditCheckDeferredContent12}
            <PhoneLink phoneNumber={creditCheckDeferredContentPhoneNo} />
          </p>

          <p>
            {creditCheckDeferredContent13}
            <br />
            {creditCheckDeferredContent14}
            <br />
            {creditCheckDeferredContent15}
          </p>
        </StandardBody>
      </div>
    )}
  </Content>
);
export default CreditCheckDeferredPage;
